import React from 'react';
import styled from 'styled-components';

import { flexCenter } from '../../style/reusableStyle';
import Typography from '../Typography';

const ContainerStyled = styled.div`
  ${flexCenter(50)};
  flex-direction: column;
  width: 100%;
  height: 50vh;
  background: ${({ theme }) => theme.colors.munsellBlue.faded};
  border-radius: 40px;
`;

const NotAlloweded = () => {
  return (
    <ContainerStyled>
      <Typography
        variant="heading"
        strong
        size={50}
        fontFamily="Libre Franklin"
        fontColor="dark"
      >
        Insufficient Role.
      </Typography>
      <Typography
        variant="heading"
        strong
        fontFamily="Libre Franklin"
        fontColor="border"
      >
        Sorry you don't have access permission.
      </Typography>
    </ContainerStyled>
  );
};

export default NotAlloweded;
